/*
 *************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 *************************************************************************
 */

import {PromiseUtils} from './PromiseUtils';

// TODO: Adding it here incase we decide to use it in future
const openLink = (
	url: string | undefined,
	target?: string,
	isAdobe?: boolean,
	isExcludeNoreferrer?: boolean,
): void => {
	if (typeof document !== 'undefined' && typeof window !== 'undefined' && url) {
		const a = document.createElement('a');
		a.href = url;
		a.target = target || '_blank';
		isAdobe
			? null
			: (a.rel = `noopener ${isExcludeNoreferrer ? '' : 'noreferrer'}`);
		a.click();
	}
};

const open = (
	url: string | undefined,
	target?: string,
	windowFeatures?: string,
	isAdobe = true,
): void => {
	const additionalWindowFeatures =
		isAdobe && windowFeatures
			? windowFeatures.concat('noopener noreferrer')
			: 'noopener noreferrer';
	window.open(url, target || '_self', additionalWindowFeatures);
};

const redirectToExternalLink = async (
	inputUrl: string,
	target?: string,
	postRedirectCb?: Function,
	timer = 1500,
) => {
	if (typeof postRedirectCb === 'function') {
		const promise = postRedirectCb();
		if (target === '_self') {
			await PromiseUtils.waitForPromise(timer, promise);
		}
	}
	open(inputUrl, target ? target : '_blank');
};

const OpenUtils = {
	open,
	openLink,
	redirectToExternalLink,
};

export {OpenUtils};
